import React from 'react';
import MarkdownPage from '../components/MarkdownPage';

// Contest "Tylko złe odpowiedzi!" rules; reachable only via direct link (not linked from the site)
const CONTEST_TERMS_URL = 'https://zwyk0bucket0prod0nuvog6.blob.core.windows.net/zwyk-public-prod/regulamin-konkurs.md';

const ContestTerms: React.FC = () => (
  <MarkdownPage url={CONTEST_TERMS_URL} loadingText="Ładowanie regulaminu konkursu…" />
);

export default ContestTerms;
